import { Outlet } from "react-router";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { Alert403 } from "@/shared/components/alerts/alert-403";
import { BaseDataPage } from "../_components/layout/base-data-page";

export function AuthRoute() {
  const canAccess = useFeatureAuth("gsm.auth");
  if (!canAccess) {
    return (
      <BaseDataPage>
        <Alert403 />
      </BaseDataPage>
    );
  }

  return <Outlet />;
}
